import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";

import io from "socket.io-client";

import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faBell,
  faChevronDown,
  faFacebookSquare,
  faCartArrowDown,
  faArrowLeft,
  faTimes,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";

import axios from "axios";
import { server } from "../../utills/utils";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions/actionTypes";

import LocationModal from "../../components/Modals/CommonModal";
import CartModal from "../Modals/CartModal";
import UserModal from "../Modals/SignModal";
import CartView from "../Cart/Cart";
import Spinner from "../Modals/SpinnerModal";
import MenuModal from "../Modals/Menu";
import CatView from "./CatView";
import CatViewActive from "./CatViewaActive";
import Avatar from "../../assets/virat.png";
import NotificationModal from "../Modals/Notification";
import Notifications from "./UserNotifications";

import GrocerryIcon from "../../assets/caticon/Grocey.png";
import ElectronicsIcon from "../../assets/caticon/Electronics.png";
import MobileIcon from "../../assets/caticon/Mobile.png";
import FurnitureIcon from "../../assets/caticon/Furniture.png";
import TechnicalIcon from "../../assets/caticon/Technical.png";
import Logo from "../../assets/Maplun.svg";

import styled from "styled-components";

import Pin from "../../assets/pin.svg";

import "../../App.css";

const MainNav = styled.div`
  width: 100%;
`;

const NavContainer = styled.div`
  width: 100%;
  height: 60px;
  background: white;
  position: fixed;
  border-bottom: 1px solid #eee;
  @media (max-width: 1100px) {
    display: none;
  }
`;

const MobileNav = styled.div`
  width: 100%;
  height: 60px;
  background: white;
  position: fixed;
  border-bottom: 1px solid #eee;
  @media (min-width: 1100px) {
    display: none;
  }
`;
const Nav = styled.div`
  width: 81.7%;
  height: 100%;
  margin-left: 8.5%;
`;
const NavLeft = styled.div`
  width: 80%;
  height: 100%;
  float: left;
`;
const NavRight = styled.div`
  width: 15%;
  height: 50%;
  float: right;
  padding-top: 1.8%;
`;
const Button = styled.button`
  background: none;
  border: none;
  outline: none;
  float: right;
  font-size: 1.2em;
  margin-left: 8px;
  cursor: pointer;
  font-weight: 500;
`;
const NavLink = styled(Link)`
  text-decoration: none;
  color: black;
`;
const LogoContainer = styled.div`
  width: 20%;
  height: 50%;
  float: left;
  padding-top: 1.2%;
`;
const LogoTitle = styled.h1`
  width: 100%;
  font-size: 1.5em;
  margin: 0;
  padding: 0;
  text-align: left;
`;
const LocationContainer = styled.div`
  width: 70%;
  height: 65%;
  float: right;
  margin-top: 1.2%;
  border: 1px solid #eee;
  border-radius: 5px;
  text-align: left;
  cursor: pointer;
`;
const LocationButton = styled.button`
  padding: 0;
  border: none;
  outline: none;
  background: none;
  padding: 10px 5px;
`;
const LocationButton2 = styled.button`
  padding: 0;
  border: none;
  outline: none;
  background: none;
  padding: 12px 10px 0 0;
  float: right;
  cursor: pointer;
  color: #276fb7;
`;
const LocationButton3 = styled.button`
  padding: 0;
  border: none;
  outline: none;
  background: none;
  padding: 4px 10px;
  float: right;
  cursor: pointer;
  color: #276fb7;
`;

const LocationImage = styled.img`
  width: 15px;
  height: 15px;
`;
const LocationContainer2 = styled.div`
  width: 100%;
  height: auto;
  text-align: left;
  padding: 30px 40px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const LocationTitle = styled.h3`
  margin: 0;
  padding: 0 0 10px 0;
  font-weight: 500;
  font-size: 1.5em;
`;
const LocationInput = styled.select`
  width: 48%;
  padding: 13px 10px;
  border: 1px solid #eee;
  outline: none;
  font-size: 1em;
  border-radius: 5px;
  margin-right: 1%;
`;
const LocationSubmit = styled.button`
  text-align: center;
  width: 100%;
  outline: none;
  padding: 13px 10px;
  margin: 20px 0 0 0;
  border: none;
  cursor: pointer;
  font-size: 1em;
  font-weight: 500;
  background: #276fb7;
  border: 1px solid #276fb7;
  color: white;
  border-radius: 5px;
`;
const AvatarImage = styled.img`
  width: 25px;
  height: 25px;
`;
const Title = styled.h2`
  margin: 0;
  padding: 0 0 20px 0;
  color: #e75016;
  font-weight: 500;
`;
const Input = styled.input`
  width: 95%;
  padding: 13px 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  margin: 5px 0;
  font-size: 1em;
`;
const Button2 = styled.button`
  width: 100%;
  padding: 13px 0;
  margin: 10px 0 20px 0;
  border: none;
  color: white;
  outline: none;
  background: #f97a7a;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;

const MenuItem = styled(Link)`
  display: block;
  padding: 10px;
  width: 90%;
  margin: 0 0 5px 0;
  font-weight: 500;
  color: black;
  text-decoration: none;
  border-radius: 5px;
  &:hover {
    background: #e9ebec;
    color: #f9701f;
  }
`;
const AllCategory = styled.div`
  width: 101%;
  padding: 0 0 20px 0;
  display: flex;
  flex-flow: wrap;
  justify-content: space-betwen;
`;
const SignImg = styled.img`
  width: 50%;
  height: 120px;
  text-align: center;
`;
const NotiBadge = styled.span`
  position: absolute;
  top: 7px;
  right: 12.5%;
  padding: 4px 8px;
  border-radius: 50%;
  background-color: #276fb7;
  color: white;
  font-size: 12px;
`;
const NotiBadgeCart = styled.span`
  position: absolute;
  top: 7px;
  right: 14.7%;
  padding: 4px 8px;
  border-radius: 50%;
  background-color: #276fb7;
  color: white;
  font-size: 12px;
  @media (max-width: 769px) {
    right: 22%;
  }
`;
const NotiBadgeCart2 = styled.span`
  position: absolute;
  top: 7px;
  right: 17%;
  padding: 4px 8px;
  border-radius: 50%;
  background-color: #276fb7;
  color: white;
  font-size: 12px;
  @media (max-width: 769px) {
    right: 22%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  padding: 7px 10px;
  cursor: pointer;
  border: 1px solid #ccc;
  background: none;
  border-radius: 100%;
  top: -10px;
  right: -10px;
  background: white;
  &:hover {
    background: #e9ebec;
    color: #f9701f;
  }
`;
const LogoContainerMob = styled(Link)`
  width: 40%;
  height: 100%;
  float: left;
`;
const MobileOptions = styled.div`
  width: 40%;
  height: auto;
  margin-top: 20px;
  float: right;
`;
const LogoImgBig = styled.img`
  width: 150px;
  height: 35px;
`;
const MobileLogoImg = styled.img`
  width: 150px;
  height: 32px;
  margin-top: 10px;
`;
const NotificationHeader = styled.div`
  width: 100%;
  height: 5.5%;
  font-size: 20px;
`;
const CloseNotification = styled.span`
  margin-right: 20px;
  cursor: pointer;
  @media (min-width: 799px) {
    display: none;
  }
`;

let socket;
function MainNavigation(props) {
  const [cartView, setCartView] = useState(false);
  const [userModal, setUserModal] = useState(false);
  const [signInView, setSignInView] = useState(true);
  const [signUpView, setSignUpView] = useState(false);
  const [redirect, setRedirect] = useState("");
  const [locationModal, setLocationModal] = useState(false);
  const [location, setLocation] = useState(localStorage.location);
  const [message, setMessage] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [menu, setMenu] = useState(false);
  const [thanas, setThanas] = useState([]);
  const [catId, setCatId] = useState(localStorage.catId);
  const [catIndex, setCatIndex] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [thanaId, setThanaId] = useState(null);
  const [notiModal, setNotiModal] = useState(false);
  const [notifications, setNotis] = useState([]);
  const [newNoti, setNewNoti] = useState(0);
  const [notiDone, setNotiDone] = useState(false);

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const icons = [
    GrocerryIcon,
    ElectronicsIcon,
    MobileIcon,
    FurnitureIcon,
    TechnicalIcon,
  ];

  const menuHandler = () => {
    setMenu(!menu);
  };
  const notificationHandler = async () => {
    if (notiModal) {
      setNotiModal(false);
    } else {
      try {
        setNewNoti(0);
        setNotiModal(!notiModal);
        await axios
          .post(server, {
            query: `
                    query{
                      userNotifications(userId:"${props.utils.userId}"){
                        _id
                        userId
                        notificationType
                        shopId
                        isSeen
                        isDetailsSeen
                        orderNo
                        shop{
                          _id
                          name
                        }
                      }
                    }
                  `,
          })
          .then((res) => {
            if (res) {
              // console.log("Noti res", res);
              setNotis(res.data.data.userNotifications);
              setNotiDone(true);
              //setComplete(true);
            }
          });
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  };
  const cartHandler = () => {
    setCartView(!cartView);
  };
  const userModalHandler = () => {
    setUserModal(!userModal);
    setSignInView(true);
    setSignUpView(false);
  };
  const userModalHandler2 = () => {
    setUserModal(!userModal);
    setSignInView(false);
    setSignUpView(true);
  };
  const checkoutHandler = () => {
    if (localStorage.TOKEN) {
      if (props.cart.length > 0) {
        setCartView(!cartView);
        setRedirect(<Redirect to="/checkout" />);
      }
    } else {
      setCartView(!cartView);
      setUserModal(!userModal);
      props.setCheckout();
    }
  };

  const locationHandler = () => {
    // if (localStorage.cityId && localStorage.catId && localStorage.thanaId) {
    setLocationModal(!locationModal);
    /// }
    // setTimeout(() => setLocationModal(!locationModal), 3000);
  };

  const setLocationHandler = async () => {
    try {
      if (location && location.length > 3) {
        props.setLocation();
        localStorage.setItem("location", location);
        setLocationModal(false);
        setRedirect(<Redirect to="/" />);
        const shops = await axios.post(server, {
          query: `
                query{
                  searchShops(location:"${localStorage.location}"){
                    _id
                    name
                    location
                    cityName
                    thanaName
                  }
                }
              `,
        });
        console.log(shops);
        const data = {
          shops: shops.data.data.searchShops,
          location: location,
        };
        props.setShops(data);
      }
    } catch (error) {
      throw error;
    }
  };
  const searchHandler = async () => {
    try {
      if (catId && thanaId && cityId) {
        props.setLocation();
        // localStorage.setItem("location", location);
        localStorage.setItem("catName", categories[catIndex].name);
        localStorage.setItem("catId", catId);
        localStorage.setItem("cityId", cities[cityId]._id);
        localStorage.setItem("cityName", cities[cityId].name);
        localStorage.setItem("thanaId", thanas[thanaId]._id);
        localStorage.setItem("thanaName", thanas[thanaId].name);
        setRedirect(<Redirect to="/" />);
        setLocationModal(false);
        console.log(catId, cities[cityId]._id, thanas[thanaId]._id);
        const shops = await axios.post(server, {
          query: `
                query{
                  searchShopsActive(catId:"${catId}",cityId:"${cities[cityId]._id}",thanaId:"${thanas[thanaId]._id}"){
                    _id
                    userName
                    name
                    cityName
                    thanaName
                    coverImage
                    localAddress
                  }
                }
              `,
        });
        console.log(shops);
        const data = {
          shops: shops.data.data.searchShopsActive,
        };
        props.setShops(data);
        console.log(
          localStorage.catId,
          localStorage.thanaId,
          localStorage.cityId
        );
      }
    } catch (error) {
      throw error;
    }
  };
  const catChangeHandler = (id, index) => {
    setCatId(id);
    localStorage.setItem("catId", id);
    localStorage.setItem("catIndex", index);
    // localStorage.setItem("catName",categories[index].name);
    setCatIndex(index);
  };
  const cityChangeHandler = (e) => {
    //debugger;
    const val = e.target.value;
    if (val !== "none") {
      //localStorage.setItem("cityId", cities[val].id);
      //localStorage.setItem("cityName", cities[val].name);
      setCityId(val);
      localStorage.setItem("cityIndex", val);
      setThanas(cities[val].thanas);
      setThanaId(null);
    } else {
      localStorage.removeItem("cityId");
    }
  };
  const thanaChangeHandler = (e) => {
    const val = e.target.value;
    if (val !== "none") {
      // localStorage.setItem("thanaId", thanas[val].id);
      // localStorage.setItem("thanaName", thanas[val].name);
      localStorage.setItem("thanaIndex", val);
      setThanaId(val);
    } else {
      localStorage.removeItem("thanaId");
    }
  };
  const fetchUser = async () => {
    try {
      await axios
        .post(server, {
          query: `
             query{
              user(token:"${localStorage.TOKEN}"){
                _id
                user_name
                email
                phone
                newNotification
                delivery_address
              }
             }
          `,
        })
        .then((res) => {
          const user = res.data.data.user;
          props.setUser(user);
          console.log("UK user", res);
          setNewNoti(user.newNotification);
          // if (res.data.errors.length === 0) {
          //   if (user.data && user.data !== null) {
          //     props.setUser(user.data.data.user);
          //   }
          // }
        });
    } catch (error) {
      throw error;
    }
  };

  const signUpHandler = async () => {
    try {
      if (phone && password) {
        setSpinner(true);
        setMessage("");
        const user = await axios.post(server, {
          query: `
               mutation{
                 signUp(phone:"${phone}", password:"${password}"){
                   success
                   userId
                   token
                   error_message
                   delivery_address
                 }
               }
             `,
        });
        console.log(user);
        if (user.data.data.signUp.success) {
          localStorage.setItem("TOKEN", user.data.data.signUp.token);
          setUserModal(!userModal);
          props.setUser(user.data.data.signUp);
          setPhone("");
          setPassword("");
          if (props.checkout) {
            setRedirect(<Redirect to="/checkout" />);
          }
        } else {
          setMessage(user.data.data.signUp.error_message);
        }

        setSpinner(false);
      }
    } catch (error) {
      throw error;
    }
  };

  const signInHandler = async () => {
    try {
      if (phone && password) {
        setSpinner(true);
        setMessage("");
        const user = await axios.post(server, {
          query: `
               query{
                 signIn(phone:"${phone}", password:"${password}"){
                   success
                   userId
                   token
                   error_message
                   phone
                   user_name
                   
                 }
               }
             `,
        });
        console.log(user);
        if (user.data.data.signIn.success) {
          localStorage.setItem("TOKEN", user.data.data.signIn.token);
          setUserModal(!userModal);
          props.setUser(user.data.data.signIn);
          setPhone("");
          setPassword("");
          if (props.checkout) {
            setRedirect(<Redirect to="/checkout" />);
          }
        } else {
          setMessage(user.data.data.signIn.error_message);
        }
        setSpinner(false);
      }
    } catch (error) {
      throw error;
    }
  };
  const onSuccess = async (user) => {
    console.log(user);
    setSpinner(true);
    await axios
      .post(server, {
        query: `
             mutation{
               socialSignIn(email:"${user.profileObj.email}", userName:"${user.profileObj.name}"){
                   error_message
                   success
                   token
                   userId
                   delivery_address
                   user_name
                }
             }
         `,
      })
      .then((res) => {
        if (res) {
          console.log(res);
          setSpinner(false);
          //localStorage.setItem('TOKEN', res.data.data.googleSignIn.token);
          // props.signIn(user_signin.data.data.googleSignIn.userId, user_signin.data.data.googleSignIn.paidMembership);
          // setRedirectUrl(<Redirect to="/"/>);
          const data = res.data.data.socialSignIn;
          localStorage.setItem("TOKEN", data.token);
          setUserModal(!userModal);
          props.setUser(data);
          setPhone("");
          setPassword("");
          if (props.checkout && props.cart.length > 0) {
            setRedirect(<Redirect to="/checkout" />);
          }
        }
      });
  };

  const onSuccessFacebook = async (user) => {
    console.log(user);
    setSpinner(true);
    await axios
      .post(server, {
        query: `
             mutation{
               socialSignIn(email:"${user.email}", userName:"${user.name}"){
                   error_message
                   success
                   token
                   userId
                   delivery_address
                   user_name
                }
             }
         `,
      })
      .then((res) => {
        if (res) {
          console.log(res);
          setSpinner(false);
          //localStorage.setItem('TOKEN', res.data.data.googleSignIn.token);
          // props.signIn(user_signin.data.data.googleSignIn.userId, user_signin.data.data.googleSignIn.paidMembership);
          // setRedirectUrl(<Redirect to="/"/>);
          const data = res.data.data.socialSignIn;
          localStorage.setItem("TOKEN", data.token);
          setUserModal(!userModal);
          props.setUser(data);
          setPhone("");
          setPassword("");
          if (props.checkout && props.cart.length > 0) {
            setRedirect(<Redirect to="/checkout" />);
          }
        }
      });
  };

  const logoutHandler = () => {
    try {
      localStorage.removeItem("TOKEN");
      setMenu(!menu);
      props.logOut();
    } catch (error) {
      throw error;
    }
  };

  const fetchCategories = async () => {
    try {
      const fetchCategories = await axios.post(server, {
        query: `
           query{
            allCategories{
              _id
              name
            }
           }
          
          `,
      });
      setCategories(fetchCategories.data.data.allCategories);
      console.log(fetchCategories);
    } catch (error) {
      throw error;
    }
  };

  const fetchCities = async () => {
    try {
      const cities = await axios.post(server, {
        query: `
           query{
            getCities{
              _id
              name
              thanas{
                _id
                name
              }
            }
           }
          
          `,
      });
      // if (fetchCities.data && fetchCities.data.data) {
      setCities(cities.data.data.getCities);
      console.log("All Cities", cities);
      if (localStorage.cityId) {
        cities.data.data.getCities.map((city) => {
          if (city._id === localStorage.cityId) {
            setThanas(city.thanas);
          }
        });
      }
      //}
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchCities();

    if (!localStorage.cityId && !localStorage.catId && !localStorage.thanaId) {
      setLocationModal(true);
    } else {
      setCityId(localStorage.cityIndex);
      setThanaId(localStorage.thanaIndex);
      setCatId(localStorage.catId);
      setCatIndex(localStorage.catIndex);
    }

    if (localStorage.TOKEN) {
      fetchUser();
    }

    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    // this.setState({
    //   cartItems: cart,
    // });
    props.setCart(cart);
  }, []);
  useEffect(() => {
    // const {name, room } = queryString.parse(location.search);
    // console.log(name,room);

    // setName(name);
    // setRoom(room);
    var connectionOptions = {
      "force new connection": true,
      reconnectionAttempts: "Infinity",
      timeout: 10000,
      transports: ["websocket"],
    };
    socket = io(server, connectionOptions);
    console.log(socket);

    //    socket.emit('join', {name, room}, ({error})=>{
    //        alert(error);
    //    });
    return () => {
      // socket.emit("disconnect");
      //socket.off();
    };
  }, []);
  const allCategories = categories.map((cat, index) => {
    if (cat._id == catId) {
      return (
        <CatViewActive
          catChangeHandler={catChangeHandler}
          key={cat.id}
          cat={cat}
          index={index}
          icon={icons[index]}
        />
      );
    } else {
      return (
        <CatView
          catChangeHandler={catChangeHandler}
          key={cat.id}
          cat={cat}
          index={index}
          icon={icons[index]}
        />
      );
    }
  });
  let area = localStorage.cityName + " , " + localStorage.thanaName;
  return (
    <MainNav>
      <MenuModal show={menu} clicked={menuHandler}>
        <div style={{ textAlign: "left", padding: "0 4%" }}>
          <MenuItem onClick={menuHandler} to="/user-profile">
            Your Account
          </MenuItem>
          <MenuItem onClick={menuHandler} to="/user-profile/orders">
            Your orders
          </MenuItem>
          <MenuItem onClick={menuHandler} to="/user-profile/favourites">
            Favourite Shops
          </MenuItem>
          <MenuItem onClick={logoutHandler}>Logout</MenuItem>
        </div>
      </MenuModal>
      <NotificationModal show={notiModal} clicked={notificationHandler}>
        <NotificationHeader>
          <CloseNotification onClick={notificationHandler}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </CloseNotification>
          Notifications
        </NotificationHeader>
        {notiDone ? (
          <Notifications
            notifications={notifications}
            userId={props.utils.userId}
            clicked={notificationHandler}
          />
        ) : null}
      </NotificationModal>
      <Spinner show={spinner} />
      {redirect}
      <LocationModal show={locationModal} closeModal={locationHandler}>
        <LocationContainer2>
          <LocationTitle>
            Choose category
            <CloseButton onClick={locationHandler}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </LocationTitle>
          <AllCategory>
            {/* {categories.map((cat) => (
              cat.id === catId ?
               (
                <CatView
                  catChangeHandler={catChangeHandler}
                  key={cat.id}
                  cat={cat}
                />
              )
              :
               (
                <CatView
                  catChangeHandler={catChangeHandler}
                  key={cat.id}
                  cat={cat}
                />
              )
            )} */}
            {/* { categories.map((cat) => {
              cat.id == catId ? (
                <CatViewActive
                  catChangeHandler={catChangeHandler}
                  key={cat.id}
                  cat={cat}
                />
              ) : (
                <CatView
                  catChangeHandler={catChangeHandler}
                  key={cat.id}
                  cat={cat}
                />
              );
            })} */}
            {allCategories}
          </AllCategory>
          {/* <LocationInput
            value={location}
            onChange={(e) => {
              setLocation(e.target.value);
            }}
            placeholder="Type location"
          /> */}
          <div style={{ width: "103%" }}>
            <LocationInput onChange={cityChangeHandler}>
              <option value="none">Select City</option>
              {cities.map((city, i) => {
                if (city._id === localStorage.cityId) {
                  return (
                    <option value={i} selected>
                      {city.name}
                    </option>
                  );
                } else {
                  return <option value={i}>{city.name}</option>;
                }
              })}
            </LocationInput>
            <LocationInput onChange={thanaChangeHandler}>
              <option>Select Thana</option>
              {thanas.map((thana, id) => {
                if (thana._id === localStorage.thanaId) {
                  return (
                    <option value={id} selected>
                      {thana.name}
                    </option>
                  );
                } else {
                  return <option value={id}>{thana.name}</option>;
                }
              })}
            </LocationInput>
          </div>
          <LocationSubmit onClick={searchHandler}>Search</LocationSubmit>
        </LocationContainer2>
      </LocationModal>
      <CartModal show={cartView} closeModal={cartHandler}>
        <div style={{ width: "100%", height: "100%" }}>
          <CartView
            closeModal={cartHandler}
            checkoutHandler={checkoutHandler}
          />
        </div>
        {/* <button onClick={checkoutHandler}>Checkout</button> */}
      </CartModal>
      <UserModal show={userModal} closeModal={userModalHandler}>
        {signInView ? (
          <div style={{ padding: "10% 0" }}>
            {/* <div>
              <SignImg src={SignIllustration}/> 
            </div> */}
            <CloseButton onClick={userModalHandler}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
            <Title>Maplun Customer</Title>
            {/* <Input
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
                type="number"
                placeholder="Phone"
              />
              <Input
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                type="password"
                placeholder="Password"
              />
              <p style={{ color: "red" }}>{message}</p>
              <div>
                <Button2 onClick={signInHandler}>Sign in</Button2>
              </div> */}
            <GoogleLogin
              //clientId="43347942474-b65ts1ab58is4bmhkeqduiot2l3u82fl.apps.googleusercontent.com"
              clientId="1062346429612-ck65ijfsorn8egef8qi4p0g2lcpacnpv.apps.googleusercontent.com"
              onSuccess={onSuccess}
              render={(renderProps) => (
                <button
                  onClick={renderProps.onClick}
                  // style={{ width: "50%", color: "green" }}
                  className="my-google-button-class"
                >
                  {/* <FontAwesomeIcon icon={faGoogle} /> */}
                  Continue with google
                </button>
              )}
              buttonText="Continue with google"
              // cssClass="my-facebook-button-class"
              style={{ width: "50%", color: "green" }}
            />
            <FacebookLogin
              appId="1044411869734344"
              fields="name,email,picture"
              cssClass="my-facebook-button-class"
              // onClick={componentClicked}
              callback={onSuccessFacebook}
              textButton="Continue with facebook"
              icon={<i className="fab fa-facebook-square"></i>}
            />
            {/* <p>
              Click “Sign In” to agree to Maplun’s Terms of Service and
              acknowledge that Maplun’s Privacy Policy applies to you.
            </p> */}
            {/* <p>
                Havent't Account ?{" "}
                <button
                  onClick={() => {
                    setSignInView(false);
                  }}
                  style={{
                    color: "#f9701f",
                    border: "none",
                    background: "none",
                    fontSize: "1em",
                    cursor: "pointer",
                  }}
                >
                  Sign up
                </button>
              </p> */}
          </div>
        ) : (
          <div style={{ padding: "10% 0" }}>
            <Title>Mamatovai Sign up</Title>
            <Input
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              type="number"
              placeholder="Phone"
            />
            <Input
              value={password}
              onChange={(e) => {
                setPassword(e.target.password);
              }}
              type="password"
              placeholder="Password"
            />
            <p style={{ color: "red" }}>{message}</p>
            <div>
              <Button2 onClick={signUpHandler}>Sign up</Button2>
            </div>
            <p>
              Already have an account ?{" "}
              <button
                onClick={() => {
                  setSignInView(true);
                }}
                style={{
                  color: "#f9701f",
                  border: "none",
                  background: "none",
                  fontSize: "1em",
                  cursor: "pointer",
                }}
              >
                Sign in
              </button>
            </p>
          </div>
        )}
      </UserModal>
      <MobileNav>
        <div style={{ width: "90%", height: "100%" }}>
          <LogoContainerMob to="/">
            <MobileLogoImg
              src={Logo}
              alt="Maplun"
              onClick={() => {
                setLocationModal(!locationModal);
              }}
            />
          </LogoContainerMob>
          <MobileOptions>
            {props.auth || localStorage.TOKEN ? (
              <div>
                <Button onClick={menuHandler}>
                  {/* <NavLink> */}
                  {/* <AvatarImage src={Avatar} alt="avatar" /> */}
                  <FontAwesomeIcon icon={faUser} />
                  {/* </NavLink> */}
                </Button>
                <Button onClick={notificationHandler}>
                  {/* <FontAwesomeIcon icon={faBell} /> */}
                  <span>
                    <FontAwesomeIcon icon={faBell} />
                  </span>
                  {newNoti && newNoti > 0 ? (
                    <NotiBadge>{newNoti}</NotiBadge>
                  ) : null}
                </Button>
                <Button onClick={cartHandler}>
                  <span>
                    <FontAwesomeIcon icon={faCartArrowDown} />
                  </span>
                  <NotiBadgeCart>{props.cart.length}</NotiBadgeCart>
                  {/* <span style={{ color: "red" }}>{props.cart.length}</span> */}
                </Button>
              </div>
            ) : (
              <div>
                {/* <Button>
                  <NavLink onClick={userModalHandler}>Sign up</NavLink>
                </Button> */}
                <Button>
                  <NavLink onClick={userModalHandler}>Sign in</NavLink>
                </Button>
                <Button onClick={cartHandler}>
                  <span>
                    <FontAwesomeIcon icon={faCartArrowDown} />
                  </span>
                  <NotiBadgeCart2>{props.cart.length}</NotiBadgeCart2>
                  {/* {" "}
                    Basket{" "}
                    <span style={{ color: "red" }}>{props.cart.length}</span> */}
                </Button>
              </div>
            )}
          </MobileOptions>
        </div>
      </MobileNav>
      <NavContainer>
        <Nav>
          <NavLeft>
            <LogoContainer>
              {/* <LogoTitle> */}
              <Link to="/" style={{ color: "#DA340E", textDecoration: "none" }}>
                <LogoImgBig
                  src={Logo}
                  alt="mamatovai"
                  onClick={() => {
                    setLocationModal(!locationModal);
                  }}
                />
              </Link>
              {/* </LogoTitle> */}
            </LogoContainer>
            <LocationContainer onClick={locationHandler}>
              <div
                style={{
                  width: "55%",
                  height: "100%",
                  float: "left",
                  borderRight: "1px solid #eee",
                }}
              >
                <LocationButton>
                  <LocationImage src={Pin} />
                </LocationButton>
                {area &&
                area.length > 0 &&
                localStorage.cityName !== undefined &&
                localStorage.thanaName
                  ? area
                  : "Location"}
                <LocationButton2>
                  <FontAwesomeIcon icon={faChevronDown} />
                </LocationButton2>
              </div>
              <p
                style={{
                  width: "40%",
                  float: "right",
                  borderRight: "1px solid #eee",
                  margin: "0",
                  padding: "8px 0",
                  color: "#276FB7",
                  fontWeight: "600",
                }}
              >
                {console.log("cat", localStorage.catName)}
                {localStorage.catName && localStorage.catName !== undefined
                  ? localStorage.catName
                  : "Category"}
                <LocationButton3>
                  <FontAwesomeIcon icon={faChevronDown} />
                </LocationButton3>
              </p>
            </LocationContainer>
          </NavLeft>
          {
            // props.utils.userSetup ?
            <NavRight>
              {props.auth || localStorage.TOKEN ? (
                <div>
                  <Button onClick={menuHandler}>
                    {/* <NavLink> */}
                    {/* <AvatarImage src={Avatar} alt="avatar" /> */}
                    <FontAwesomeIcon icon={faUser} />
                    {/* </NavLink> */}
                  </Button>
                  <Button onClick={notificationHandler}>
                    {/* <FontAwesomeIcon icon={faBell} /> */}
                    <span>
                      <FontAwesomeIcon icon={faBell} />
                    </span>
                    {newNoti && newNoti > 0 ? (
                      <NotiBadge>{newNoti}</NotiBadge>
                    ) : null}
                  </Button>
                  <Button onClick={cartHandler}>
                    <span>
                      <FontAwesomeIcon icon={faCartArrowDown} />
                    </span>
                    <NotiBadgeCart>{props.cart.length}</NotiBadgeCart>
                    {/* <span style={{ color: "red" }}>{props.cart.length}</span> */}
                  </Button>
                </div>
              ) : (
                <div>
                  {/* <Button>
                    <NavLink onClick={userModalHandler}>Sign up</NavLink>
                  </Button> */}
                  <Button>
                    <NavLink onClick={userModalHandler}>Sign in</NavLink>
                  </Button>
                  <Button onClick={cartHandler}>
                    <span>
                      <FontAwesomeIcon icon={faCartArrowDown} />
                    </span>
                    <NotiBadgeCart2>{props.cart.length}</NotiBadgeCart2>
                    {/* {" "}
                    Basket{" "}
                    <span style={{ color: "red" }}>{props.cart.length}</span> */}
                  </Button>
                </div>
              )}
            </NavRight>
            // : null
          }
        </Nav>
      </NavContainer>
    </MainNav>
  );
}

const mapStateToProps = (state) => {
  return {
    cart: state.utils.cart,
    name: state.utils.name,
    auth: state.utils.auth,
    utils: state.utils,
    checkout: state.utils.checkout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCart: (cart) => {
      dispatch({
        type: actionTypes.SET_CART,
        cart,
      });
    },
    setUser: (user) => {
      dispatch({
        type: actionTypes.AUTH_USER,
        user,
      });
    },
    setLocation: () => {
      dispatch({
        type: actionTypes.HOME_LOAD_CHANGE,
      });
    },
    setCheckout: () => {
      dispatch({
        type: actionTypes.SET_CHECKOUT,
      });
    },
    setShops: (data) => {
      dispatch({
        type: actionTypes.SET_SHOPS_CHANGE,
        data,
      });
    },
    logOut: () => {
      dispatch({
        type: actionTypes.USER_LOGOUT,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainNavigation);
